import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useAuthContext } from "./useAuthContext";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";

// Don't block UI forever when Auth0 hangs (e.g. bad cache/authorize issues)
const AUTH_LOADING_TIMEOUT_MS = 8000;

export const GuestGuard = ({ children }) => {
  const { isInitialized, user } = useAuthContext();
  const { isAuthenticated, isLoading } = useAuth0();
  const [loadingTimedOut, setLoadingTimedOut] = useState(false);

  useEffect(() => {
    const shouldWait = isLoading || !isInitialized || (isAuthenticated && !user);
    if (!shouldWait) {
      setLoadingTimedOut(false);
      return;
    }
    const t = setTimeout(() => setLoadingTimedOut(true), AUTH_LOADING_TIMEOUT_MS);
    return () => clearTimeout(t);
  }, [isAuthenticated, isInitialized, isLoading, user]);

  const showLoading =
    (isLoading || !isInitialized || (isAuthenticated && !user)) && !loadingTimedOut;

  if (showLoading) {
    return <LoadingScreen />;
  }

  // if (isAuthenticated && user) {
  //   return <Navigate to="/dashboard" />;
  // }

  return <> {children} </>;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};
